import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import SearchPanel from '@/components/feature/SearchPanel';

const navItems = [
  { label: '首页', to: '/' },
  { label: '资讯', to: '/news' },
  { label: '角色攻略', to: '/characters' },
  { label: '版本更新', to: '/updates' },
];

export default function Navbar() {
  const [searchOpen, setSearchOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setSearchOpen(false);
    setMobileOpen(false);
  }, [location.pathname]);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium transition-colors ${
      isActive ? 'text-primary-700' : 'text-foreground-700 hover:text-primary-600'
    }`;

  return (
    <header className="fixed inset-x-0 top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-[68px] items-center gap-4">
          <Link to="/" className="flex items-center gap-2.5 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-gamepad-line text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-display text-lg font-bold tracking-wide text-foreground-950">
                原神情报站
              </span>
              <span className="mt-0.5 text-[10px] uppercase tracking-[0.2em] text-foreground-400">
                Genshin Info
              </span>
            </span>
          </Link>

          <nav className="ml-6 hidden md:flex items-center gap-1" aria-label="主导航">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} end={item.to === '/'} className={linkClass}>
                {({ isActive }) => (
                  <>
                    {item.label}
                    {isActive && (
                      <span className="absolute -bottom-0.5 left-3 right-3 h-0.5 rounded-full bg-accent-500"></span>
                    )}
                  </>
                )}
              </NavLink>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-2">
            <button
              type="button"
              onClick={() => setSearchOpen((v) => !v)}
              aria-label="搜索"
              className="flex h-9 items-center gap-2 rounded-full border border-background-300 bg-background-50 px-3 text-sm text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-search-line text-base"></i>
              <span className="hidden lg:inline">搜索资讯 / 攻略</span>
            </button>

            <Link
              to="/updates"
              className="hidden sm:inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
            >
              <i className="ri-sparkling-line"></i>
              版本速递
            </Link>

            <button
              type="button"
              onClick={() => setMobileOpen((v) => !v)}
              aria-label="菜单"
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 md:hidden"
            >
              <i className={mobileOpen ? 'ri-close-line text-lg' : 'ri-menu-line text-lg'}></i>
            </button>
          </div>
        </div>
      </div>

      {searchOpen && <SearchPanel onClose={() => setSearchOpen(false)} />}

      {mobileOpen && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden" aria-label="移动导航">
          <div className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary-50 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </NavLink>
            ))}
            <button
              type="button"
              onClick={() => {
                setMobileOpen(false);
                setSearchOpen(true);
              }}
              className="mt-1 flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100"
            >
              搜索资讯 / 攻略
              <i className="ri-search-line text-foreground-400"></i>
            </button>
          </div>
        </nav>
      )}
    </header>
  );
}